import { HashRouter } from "react-router-dom";
import GameInit from "./components/Game/GameInit";
import GameView from "./components/Game/GameView";

import { CssBaseline, MuiThemeProvider } from '@material-ui/core'
import { ThemeProvider } from 'styled-components'
import { theme } from '../src/theme'
import ScrollBarStyles from "./components/lookAndFeel/ScrollBarStyles";

export default function App() {
	return (
		<MuiThemeProvider theme={theme}>
			<ThemeProvider theme={theme}>
				<CssBaseline />
				<ScrollBarStyles />
				<HashRouter>
					<GameInit>
						<GameView />
					</GameInit>
				</HashRouter>
			</ThemeProvider>
		</MuiThemeProvider>
	);
}